// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"6c1a424a","775":"a6c389c8","999":"dd1f1f0c"}[chunkId] + ".chunk.js";
};